import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Touch2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 11.25H20.25C20.25 6.69365 16.5563 3 12 3C7.44365 3 3.75 6.69365 3.75 11.25H2.25C2.25 5.86522 6.61522 1.5 12 1.5C17.3848 1.5 21.75 5.86522 21.75 11.25ZM18.75 21H17.25V11.25C17.25 8.3505 14.8995 6 12 6C9.1005 6 6.75 8.3505 6.75 11.25V21H5.25V11.25C5.25 7.52208 8.27208 4.5 12 4.5C15.7279 4.5 18.75 7.52208 18.75 11.25V21ZM8.25 11.25V15H15.75V11.25C15.75 9.17893 14.0711 7.5 12 7.5C9.92893 7.5 8.25 9.17893 8.25 11.25ZM14.25 11.25V13.5H9.75V11.25C9.75 10.0074 10.7574 9 12 9C13.2426 9 14.25 10.0074 14.25 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Touch2.vue"]]);
